<template>
	<div class="container">
		<div v-html="page.body"></div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			page: {
				body: ``
			}
		};
	}
};
</script>

<style lang="scss">
</style>